import React, { useContext, useState } from 'react'
import './index.sass'
import { DarkModeContext } from '../../global/Theme'

import {useHistory} from 'react-router-dom'

export default function Tab({ img, text, img2, text2, onUpdate, title }) {
    const { isDark } = useContext(DarkModeContext);
    const [isActive, setIsActive] = useState(0);
    const handleClick = (e, setIsActive) => {
        onUpdate(e, setIsActive);
    }

    const history = useHistory();
    const goBackSimonHaha = () => {
        history.goBack()
    }

    

    return (
        <div className={`lover-tab ${isDark ? 'lover-tab-dark' : 'lover-tab-light'}`}>
             <div className="lover-tab-mobile">
                <img onClick={goBackSimonHaha} src={require('../../assets/icons/backbutton.svg')} />
                <p>{title}</p>
            </div>
            <div className="lover-tab-row">
                <div onClick={()=>handleClick(0, setIsActive)}>
                    <img src={(isActive === 0) ? require(`../../assets/icons/${img}_a.svg`) :require(`../../assets/icons/${img}.svg`)} />
                    <h1>{text}</h1>
                </div>
                <div onClick={()=>handleClick(1, setIsActive)}>
                    <img src={(isActive === 1) ? require(`../../assets/icons/${img2}_a.svg`) : require(`../../assets/icons/${img2}.svg`)} />
                    <h1>{text2}</h1>
                </div>
            </div>
        </div>
    )
}
